module.exports = {
  addMail: 'addMail',
  getMail: 'getMail',
  updateMail: 'updateMail',
  listMail: 'listMail',
};
